module.exports = __webpack_public_path__ + "static/img/2.feceda5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/zh/2.png
// module id = 0BIz
// module chunks = 0